import { httpHandler } from '../httpHandler';

export const verifyCpf = (value) => httpHandler.get({url: `/cpf/${value}`});
